import React from 'react';
import logoIcon from '@/assets/logo.png';
import logoText from '@/assets/logo-text.png';
import { cn } from '@/lib/utils';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
  className?: string;
}

const iconSizeMap = {
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

const textSizeMap = {
  sm: 'h-4',
  md: 'h-5',
  lg: 'h-6',
};

export const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  showText = true,
  className 
}) => {
  return (
    <div className={cn("flex items-center space-x-2", className)}>
      <img src={logoIcon} alt="Hotel3D" className={iconSizeMap[size]} />
      {showText && (
        <img src={logoText} alt="Hotel3D" className={cn(textSizeMap[size], "w-auto")} />
      )}
    </div>
  );
};

export default Logo;
